<template>
  <div
    v-click-outside="closeEdit"
    class="tag-wrapper"
    @mouseenter="showInfoIcon = true"
  >
    <!--    v-if="checkTodaysDeposits().length > 0"-->
    <!--    v-if="checkTodaysDepositsCCREM().length > 0"-->
    <!--    v-if="checkTodaysDepositsRegular().length > 0"-->

    <!--    <span-->
    <!--            v-if="checkTodaysDeposits().length > 0 ||checkTodaysDepositsCCREM().length > 0 || checkTodaysDepositsRegular().length > 0"-->
    <!--      class=" label tag-deposit-today table-tag-content"-->
    <!--      :class="checkTodayDepositsMixed()"-->
    <!--      @mouseleave="showTodaysDeposits = false"-->
    <!--      @mouseenter="showTodaysDeposits = true"-->
    <!--      >&lt;!&ndash;<span class="fa fa-calendar"></span>&ndash;&gt;-->
    <!--      <span-->
    <!--        >{{ checkTodaysDepositsCCREM().length }} |</span-->
    <!--      ><span >-->
    <!--        {{ checkBrokersCountTwice(checkTodaysDepositsRegular()) }}</span-->
    <!--      >-->
    <!--    </span>-->
    <!--    @click="editMode = true"-->

    <span
      @click="clickedForOpenPopUp"
      v-if="deposits.length > 1"
      class="label"
      :class="tag_deposit_back_to_sale()"
    >
      <!--            :class="{'tag-deposit':deposits[0].status_id !== 9,'tag-deposit-for-back-to-sales':deposits[0].status_id === 9}"-->

      <span class="tag-time">
        <!--        @click="fillterMain"-->
        <span class="tagNameDesign">
          <span
            v-if="
              checkTodaysDeposits().length > 0 ||
                checkTodaysDepositsCCREM().length > 0 ||
                checkTodaysDepositsRegular().length > 0
            "
            :class="checkTodayDepositsMixed()"
            @mouseenter="showTodaysDeposits = true"
          >
            <!--              @mouseleave="showTodaysDeposits = false"-->
            <span class="pl-1 ml-1">
              {{ checkBrokersCountTwice(checkTodaysDepositsRegular()) }} |</span
            >
            <span class="mpl-1">{{ checkTodaysDepositsCCREM().length }} </span>
          </span>
          <span v-else>{{
            client_dep.not_interested_state_id === null ? "DP" : "NI"
          }}</span>
          <!--          client_dep.not_interested_state.short_name-->
        </span>
        {{ formatDate(deposits[0].created_at) }}
        <span class="forNumOutOfName" v-if="checkLength(deposits).length > 0">{{
          checkBrokersCountTwice(checkLength(deposits))
        }}</span>
      </span>
      <a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span></a
    ></span>
    <!-- <i  @click="editMode = true" v-if="showInfoIcon" class="fa fa-info info-icon"></i>-->

    <!--    -->
    <span
      @click="clickedForOpenPopUp"
      v-if="deposits.length === 1"
      class="label no-border"
      :class="tag_deposit_back_to_sale()"
    >
      <!--            :class="{'tag-deposit':deposits[0].status_id !== 9,'tag-deposit-for-back-to-sales':deposits[0].status_id === 9}"-->

      <span class="tag-time">
        <!--        @click="fillterMain" -->
        <span
          class="tagNameDesign"
          :class="{ BlackCc: checkTodaysDepositsCCREM().length > 0 }"
          >{{ client_dep.not_interested_state_id === null ? "DP" : "NI" }}</span
        ></span
      >
      <!--      client_dep.not_interested_state.short_name-->
      {{ formatDate(deposits[0].created_at) }}
      <a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span></a
    ></span>

    <div
      v-if="deposits.length > 0 && showTodaysDeposits"
      class="tag-table-small pop-up-for-tags"
    >
      <div
        class="table-responsive"
        @mouseleave="
          [
            (editMode = false),
            (showTodaysDeposits = false),
            endHover,
            selectedDepTab === 'QUESTIONS' || selectedDepTab === 'SUPPORT'
              ? (clickedOnDateChange = false)
              : ''
          ]
        "
      >
        <table class="table">
          <thead>
            <tr>
              <th class="t-header">DATE</th>
              <th class="t-header">TIME</th>
              <th class="t-header">AGENT</th>
              <th class="t-header">BROKER</th>
              <th class="t-header">AM</th>
              <th class="t-header">
                <i class="fas fa-pound-sign"></i
                ><i class="fas fa-dollar-sign"></i
                ><i class="fas fa-euro-sign"></i>
              </th>
              <th class="t-header">METHOD</th>
              <th class="t-header">TYPE</th>
              <th class="t-header">COMM</th>
              <th class="t-header">ID</th>
              <th class="t-header">STAT</th>

              <th class="t-header">
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @click="
                    [
                      (editMode = false),
                      (showTodaysDeposits = false),
                      endHover,
                      selectedDepTab === 'QUESTIONS' ||
                      selectedDepTab === 'SUPPORT'
                        ? (clickedOnDateChange = false)
                        : ''
                    ]
                  "
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="deposit in checkPrivilegesTable(checkTodaysDeposits())"
              v-bind:key="deposit"
            >
              <td>{{ formatDateTable(deposit.created_at) }}</td>
              <td>{{ deposit.created_at | shortTime }}</td>
              <td  >
              <span v-tooltip.bottom="{ content: deposit.user.full_name }">{{ deposit.user.full_name | truncate(5) }}</span>
              </td>
              <td class="for-broker-name">{{ deposit.campaign.name }}</td>
              <td class="text-right">{{ deposit.amount }}</td>
              <td class="text-right for-symbol">
                <span v-if="deposit.currency">{{
                  deposit.currency.symbol
                }}</span>
              </td>
              <td class="text-right for-methods">
                <span
                  v-if="deposit.method"
                  v-tooltip.bottom="{ content: deposit.method }"
                  >{{ deposit.method.method | truncate(6) }}</span
                >
              </td>
              <td>{{ deposit.type.type }}</td>
              <td>
                <span
                  v-if="deposit.comment"
                  v-tooltip.bottom="{ content: deposit.comment }"
                  >{{ deposit.comment | truncate(15) }}</span
                >
              </td>
              <td>{{ deposit.id }}</td>
              <td>
                <span
                  v-if="
                    deposit.status_id !== 4 &&
                      deposit.status_id !== 6 &&
                      deposit.status_id !== 5
                  "
                  class="trans-approved-before"
                >
                  <i class="fas fa-check"></i>
                </span>
                <span v-if="deposit.status_id === 5" class="trans-approved">
                  <i class="fas fa-check"></i>
                </span>
                <span
                  v-if="deposit.status_id === 4 || deposit.status_id === 6"
                  class="trans-declined"
                >
                  <i class="fas fa-times"></i>
                </span>
              </td>
              <td>
                {{ deposit.second_user ? deposit.second_user.full_name : "" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      v-if="editMode"
      class="tag-table pop-up-for-tags"
      :class="{ 'question-table ': selectedDepTab === 'QUESTIONS' }"
    >
      <!--      @mouseenter="showTable = false"-->
      <ul class="nav nav-tabs ">
        <!--        <li class="for-fa-times">-->
        <!--          <i-->
        <!--            class="fa fa-times"-->
        <!--            aria-hidden="true"-->
        <!--            @click="-->
        <!--              [-->
        <!--                !clickedOnDateChange ? (editMode = false) : '',-->
        <!--                endHover,-->
        <!--                selectedDepTab === 'QUESTIONS' || selectedDepTab === 'SUPPORT'-->
        <!--                  ? (clickedOnDateChange = false)-->
        <!--                  : ''-->
        <!--              ]-->
        <!--            "-->
        <!--          ></i>-->
        <!--        </li>-->
        <li
          class="pull-left"
          v-for="tab in depTabs"
          :key="tab.id"
          :class="{ active: selectedDepTab === tab.alias }"
        >
          <a href="javascript:void(0)" @click="selectedDepTab = tab.alias">
            {{ tab.name }}
          </a>
        </li>
        <li
          class="for-last-call"
          v-if="checkPrivilegesTable(deposits).length === 1"
        >
          L.C : {{ formatDateLc(checkPrivilegesTable(deposits).created_at) }}
        </li>
        <li
          class="for-last-call"
          v-if="checkPrivilegesTable(deposits).length > 1"
        >
          L.C : {{ formatDateLc(checkPrivilegesTable(deposits)[0].created_at) }}
        </li>
      </ul>
      <div v-if="selectedDepTab === 'SUPPORT'">
        <table class="table question-table">
          <thead>
            <tr>
              <th
                class="t-header"
                v-for="(question, idx) in dictionaries.activity
                  .support_deposits_questions"
                :key="idx"
              >
                {{ question.title }}
              </th>
              <th class="t-header">BROKER</th>
              <th class="t-header">SUPPORT EMAIL</th>
              <th class="t-header">DEPOSIT ID</th>
              <th class="t-header">CONTACTED BY</th>
              <th class="t-header">UPLOAD FILE</th>
              <th class="t-header">
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @click="
                    [
                      (editMode = false),
                      (showTodaysDeposits = false),
                      endHover,
                      selectedDepTab === 'QUESTIONS' ||
                      selectedDepTab === 'SUPPORT'
                        ? (clickedOnDateChange = false)
                        : ''
                    ]
                  "
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(deposit, idx) in checkPrivilegesTable(deposits)"
              :key="idx"
            >
              <td>
                <!-- :answers-list="dictionaries.activity.support_deposits_questions"-->

                <deposit-answer
                  :client="answers.answers"
                  :deposit-id="deposit.id"
                  :question-id="1"
                  @updated="$emit('updated')"
                ></deposit-answer>
              </td>
              <!-- :send-updated="sendUpdated"
                    @unlock="resetLock"
        -->
              <td>
                <!-- :answers-list="dictionaries.activity.support_deposits_questions"-->
                <deposit-answer
                  :client="answers.answers"
                  :deposit-id="deposit.id"
                  :question-id="2"
                  @updated="$emit('updated')"
                ></deposit-answer>
              </td>
              <td>
                <!-- :answers-list="dictionaries.activity.support_deposits_questions"-->
                <deposit-answer
                  :client="answers.answers"
                  :deposit-id="deposit.id"
                  :question-id="3"
                  @updated="$emit('updated')"
                ></deposit-answer>
              </td>
              <td>
                <!-- :answers-list="dictionaries.activity.support_deposits_questions"-->
                <deposit-answer
                  :client="answers.answers"
                  :deposit-id="deposit.id"
                  :question-id="4"
                  @updated="$emit('updated')"
                ></deposit-answer>
              </td>
              <td>
                <!-- :answers-list="dictionaries.activity.support_deposits_questions"-->
                <deposit-answer
                  :client="answers.answers"
                  :deposit-id="deposit.id"
                  :question-id="5"
                  @updated="$emit('updated')"
                ></deposit-answer>
              </td>
              <td>
                <!-- :answers-list="dictionaries.activity.support_deposits_questions"-->
                <deposit-answer
                  :client="answers.answers"
                  :deposit-id="deposit.id"
                  :question-id="6"
                  @updated="$emit('updated')"
                ></deposit-answer>
              </td>
              <td>
                {{
                  findBrokerNameByID(
                    showBrokerByAnsDepId(deposit.id)[0].campaign_id
                  )
                }}
              </td>
              <td class="broker_support_email">
                {{
                  findBrokerEmailByID(
                    showBrokerByAnsDepId(deposit.id)[0].campaign_id
                  )
                }}
              </td>
              <td>
                <span
                  class="show-spec-btn"
                  @click="showAnswerHistoryByDepId(deposit.id)"
                  >{{ deposit.id }}</span
                ><span
                  v-if="
                    showResetCloseAnswerHistory && ansIdToEdit === deposit.id
                  "
                  @click.prevent="clearAnswersHistorySelection()"
                  class="fas fa-times remove-tag-icon"
                ></span>
              </td>
              <td class="text-center">
                <select-component
                  :deposit="deposit"
                  :contacted="answers.contact_at"
                  @updated="$emit('updated')"
                ></select-component>
              </td>

              <td class="text-center">
                <span v-if="matchedAnswer(deposit.id) !== undefined">
                  <label
                    v-if="matchedAnswer(deposit.id).file_url === null"
                    for="input-Upload"
                    class="fas fa-cloud-upload-alt"
                    style="font-size: 20px;"
                  >
                    <input
                      type="file"
                      @change="uploadFileImage(deposit.id, $event)"
                      style="display:none"
                      id="input-Upload"
                    />
                  </label>
                  <img
                    v-else
                    width="21"
                    src="/img/icons/correct.svg"
                    style="cursor: pointer"
                    @click="
                      openDocInNewWindow(matchedAnswer(deposit.id).file_url)
                    "
                  />
                </span>

                <span v-else>
                  <img width="21" src="/img/icons/close.svg" />
                </span>
                <!--
              <div class="spinner-answer">
                <loader
                  class="spinner-bottom-ms"
                  v-if="showSpinner && deposit.id === deposit.id"
                  :size="'3px'"
                ></loader>
              </div>-->
              </td>
              <td>
                <dep-dot-indicator
                  :deposit="deposit"
                  :deposit-answers="answers.answers"
                ></dep-dot-indicator>
              </td>
            </tr>
          </tbody>
        </table>
        <button
          @click="showAnswersHistory = !showAnswersHistory"
          class="history-btn"
        >
          {{ showAnswersHistory ? "Hide History" : "Show History" }}
        </button>
      </div>
      <div
        v-if="selectedDepTab === 'BROKER'"
        @click="
          updateDepAmount();
          updateDepComment();
        "
      >
        <table class="table ">
          <thead>
            <tr>
              <th class="t-header">DATE</th>
              <th class="t-header">TIME</th>
              <th class="t-header">AGENT</th>
              <th class="t-header">BROKER</th>
              <th class="t-header">AM</th>
              <th class="t-header">
                <i class="fas fa-pound-sign"></i
                ><i class="fas fa-dollar-sign"></i
                ><i class="fas fa-euro-sign"></i>
              </th>
              <th class="t-header">METHOD</th>
              <th class="t-header">TYPE</th>
              <th class="t-header">REM</th>
              <th class="t-header">COMM</th>
              <th class="t-header">SC-BROKER</th>
              <th class="t-header">ID</th>
              <th class="t-header"></th>
              <th class="t-header">STAT</th>
              <th class="t-header">TASK</th>
              <th class="t-header">SEC</th>
              <th
                class="t-header"
                v-if="
                  client_dep.hasOwnProperty('na') && client_dep.na.length > 0
                "
              >
                NA-DEP
              </th>
              <th
                class="t-header"
                v-if="
                  client_dep.hasOwnProperty('scheduled_calls') &&
                    client_dep.scheduled_calls.length > 0
                "
              >
                SC-DEP
              </th>
              <th class="t-header">
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @click="
                    [
                      !clickedOnDateChange ? (editMode = false) : '',
                      endHover,
                      selectedDepTab === 'QUESTIONS' ||
                      selectedDepTab === 'SUPPORT'
                        ? (clickedOnDateChange = false)
                        : ''
                    ]
                  "
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(deposit, idx) in checkPrivilegesTable(deposits)"
              :key="idx"
            >
              <td
                v-show="
                  requestForDate.tagName !== 'dp' ||
                    requestForDate.id !== deposit.id
                "
              >
                <span
                  :class="{
                    inBetweenSelectedCalDates: checkSelectedCalDates(deposit)
                  }"
                  @click="
                    showChangeDate = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeUser = null;
                    showChangeAmount = null;
                    showChangeCurrency = null;
                    showChangeBroker = null;
                    showChangeMethod = null;
                    showChangeComment = null;
                    showChangeStatus = null;
                    showChangeScheduleCall = null;
                  "
                  class="date-pic td-edit"
                >
                  <span>{{ formatDateTable(deposit.created_at) }}</span>

                  <i
                    v-if="
                      requestForDate.date == null || requestForDate.time == null
                    "
                    class="fas fa-edit clickable "
                    @click="
                      [
                        sendVuexToCal(deposit),
                        (depositDate = true),
                        (clickedOnDateChange = true)
                      ]
                    "
                  ></i>
                  <i
                    @click="sendNewDateFromPopUpToDB"
                    class="fas fa-check pointer"
                    v-if="
                      requestForDate.date != null &&
                        requestForDate.time != null &&
                        requestForDate.id === deposit.id
                    "
                  ></i>
                </span>
                <!--                <div-->
                <!--                  v-if="-->
                <!--                    showChangeDate === deposit.id &&-->
                <!--                      checkPermissions(auth, [1, 2, 3, 4, 12])-->
                <!--                  "-->
                <!--                  class="date-dropdown-menu"-->
                <!--                >-->
                <!--                  <date-picker-->
                <!--                    v-model="newDate"-->
                <!--                    :first-day-of-week="1"-->
                <!--                    type="datetime"-->
                <!--                    :minute-step="1"-->
                <!--                    :time-picker-options="timePickerOptions"-->
                <!--                    input-class="form-control input-date"-->
                <!--                    :confirm="true"-->
                <!--                    lang="en"-->
                <!--                    @confirm="updateDepDate"-->
                <!--                  ></date-picker>-->
                <!--                  <span-->
                <!--                    v-if="showChangeDate === deposit.id"-->
                <!--                    @click="-->
                <!--                      showChangeDate = null;-->
                <!--                      depIdToEdit = null;-->
                <!--                    "-->
                <!--                    class="fas fa-times remove-tag-icon"-->
                <!--                  ></span>-->
                <!--                </div>-->
              </td>
              <td
                v-show="
                  requestForDate &&
                    requestForDate.tagName === 'dp' &&
                    requestForDate.id === deposit.id
                "
                :class="{ 'text-danger': depositDate }"
              >
                <i
                  v-if="
                    (requestForDate.date == null ||
                      requestForDate.time == null) &&
                      depositDate
                  "
                  class="fas fa-window-close clickable "
                  @click="
                    [
                      sendVuexToCal(),
                      (depositDate = true),
                      (clickedOnDateChange = true)
                    ]
                  "
                ></i>
                <span v-else>{{ formatDateTable(deposit.created_at) }} </span>
                <i
                  @click="sendNewDateFromPopUpToDB"
                  class="fas fa-check pointer"
                  v-if="
                    requestForDate.date != null &&
                      requestForDate.time != null &&
                      requestForDate.id === deposit.id &&
                      depositDate
                  "
                ></i>
                <span v-if="depositDate">{{ textOrDate }} </span>
              </td>
              <td>
                <span
                  :class="{
                    inBetweenSelectedCalDates: checkSelectedCalDates(deposit)
                  }"
                >
                  <span
                    class="text-danger"
                    v-if="
                      requestForDate.date != null &&
                        requestForDate.time != null &&
                        requestForDate.id === deposit.id &&
                        depositDate
                    "
                    >{{ requestForDate.time }}:00</span
                  >
                  <span v-else>{{ deposit.created_at | shortTime }}</span>
                </span>
              </td>

              <td>
                <span
                  @click="
                    showChangeUser = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeBroker = null;
                    showChangeAmount = null;
                    showChangeCurrency = null;
                    showChangeDate = null;
                    showChangeMethod = null;
                    showChangeComment = null;
                    showChangeStatus = null;
                    showChangeScheduleCall = null;
                  "
                  class="td-edit comment-p"
                  v-tooltip.bottom="{ content: deposit.user.full_name }"
                >
                  {{ deposit.user.full_name | truncate(5) }}
                  <!--                  <span-->
                  <!--                    :class="{-->
                  <!--                      'tool-comment': deposit.user.full_name.length >= 5-->
                  <!--                    }"-->
                  <!--                  >-->
                  <!--                    {{ deposit.user.full_name }}-->
                  <!--                  </span>-->
                </span>
                <ul
                  v-if="
                    showChangeUser === deposit.id &&
                      checkPermissions(auth, [1, 2, 3, 4, 12])
                  "
                  class="p-xy-8 user-dropdown-menu"
                >
                  <li class="assign-menu-item" @click="showChangeUser = null">
                    <span class="cancel-edit-menu-item"
                      >Cancel <span class="fas fa-times remove-tag-icon"></span
                    ></span>
                  </li>
                  <div class="add-tag-menu-item-title">
                    Change user to:
                  </div>

                  <li
                    @click="updateDepUser(person.id)"
                    class="assign-menu-item"
                    v-for="person in salesPersonList"
                    :key="person.id"
                    v-tooltip.bottom="{
                      content: person.first_name + ' ' + person.last_name
                    }"
                  >
                    {{
                      (person.first_name + " " + person.last_name)
                        | truncate(15)
                    }}
                  </li>
                </ul>
              </td>
              <td class="for-broker-name">
                <span
                  class="td-edit"
                  @click="
                    showChangeBroker = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeUser = null;
                    showChangeAmount = null;
                    showChangeCurrency = null;
                    showChangeDate = null;
                    showChangeMethod = null;
                    showChangeComment = null;
                    showChangeStatus = null;
                    showChangeScheduleCall = null;
                  "
                  >{{ deposit.campaign.name }}</span
                >
                <div class="floating-wrapper">
                  <ul
                    v-if="
                      showChangeBroker === deposit.id &&
                        checkPermissions(auth, [1, 2, 3, 4, 12])
                    "
                    class="p-xy-8 broker-dropdown-menu"
                  >
                    <li class="assign-menu-item">
                      <span
                        @click="showChangeBroker = null"
                        class="cancel-edit-menu-item"
                        >Cancel
                        <span class="fas fa-times remove-tag-icon"></span
                      ></span>
                    </li>
                    <div class="add-tag-menu-item-title">
                      Change broker to:
                    </div>

                    <li
                      @click="updateDepBroker(broker.id)"
                      class="assign-menu-item"
                      v-for="broker in dictionaries.general.brokers"
                      :key="broker.id"
                    >
                      {{ broker.name }}
                    </li>
                  </ul>
                </div>
              </td>
              <td class="text-right">
                <span
                  @click="
                    showChangeAmount = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeUser = null;
                    showChangeBroker = null;
                    showChangeCurrency = null;
                    showChangeDate = null;
                    showChangeMethod = null;
                    showChangeComment = null;
                    showChangeStatus = null;
                    showChangeScheduleCall = null;
                  "
                  v-if="showChangeAmount !== deposit.id"
                  class="td-edit"
                  >{{ deposit.amount }}</span
                ><span
                  ><input
                    v-model="newAmount"
                    v-if="showChangeAmount === deposit.id"
                    type="search"
                    class="amount-select"/>
                  <span
                    v-if="showChangeAmount === deposit.id"
                    @click="
                      showChangeAmount = null;
                      depIdToEdit = null;
                    "
                    class="fas fa-times remove-tag-icon"
                  ></span
                ></span>
              </td>
              <td class="text-right for-symbol">
                <span
                  @click="
                    showChangeCurrency = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeUser = null;
                    showChangeBroker = null;
                    showChangeAmount = null;
                    showChangeDate = null;
                    showChangeMethod = null;
                    showChangeComment = null;
                    showChangeStatus = null;
                    showChangeScheduleCall = null;
                  "
                  class="td-edit"
                  ><span v-if="deposit.currency">{{
                    deposit.currency.symbol
                  }}</span></span
                >

                <ul
                  v-if="
                    showChangeCurrency === deposit.id &&
                      checkPermissions(auth, [1, 2, 3, 4, 12])
                  "
                  class="p-xy-8 currency-dropdown-menu"
                >
                  <div class="add-tag-menu-item-title">
                    Change currency to:
                  </div>

                  <li
                    @click="updateDepCurrecy(curr.id)"
                    class="assign-menu-item"
                    v-for="curr in dictionaries.activity.currency_types"
                    :key="curr.id"
                  >
                    {{ curr.symbol + " " + curr.name }}
                  </li>
                  <li
                    class="assign-menu-item"
                    @click="showChangeCurrency = null"
                  >
                    <span class="cancel-edit-menu-item"
                      >Cancel <span class="fas fa-times remove-tag-icon"></span
                    ></span>
                  </li>
                </ul>
              </td>
              <td class="text-right for-methods">
                <span
                  @click="
                    showChangeMethod = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeUser = null;
                    showChangeBroker = null;
                    showChangeAmount = null;
                    showChangeDate = null;
                    showChangeCurrency = null;
                    showChangeComment = null;
                    showChangeStatus = null;
                    showChangeScheduleCall = null;
                  "
                  class="td-edit comment-p"
                  v-tooltip.bottom="{ content: deposit.method.method }"
                >
                  {{ deposit.method.method | truncate(6) }}
                  <!--                  <span-->
                  <!--                    :class="{-->
                  <!--                      'tool-comment': deposit.method.method.length >= 6-->
                  <!--                    }"-->
                  <!--                  >-->
                  <!--                    {{ deposit.method.method }}-->
                  <!--                  </span>-->

                  <!--                  <span v-if="deposit.method">{{-->
                  <!--                    deposit.method.method | truncate(6)-->
                  <!--                  }}</span>-->
                </span>

                <ul
                  v-if="
                    showChangeMethod === deposit.id &&
                      checkPermissions(auth, [1, 2, 3, 4, 12])
                  "
                  class="p-xy-8 method-dropdown-menu"
                >
                  <div class="add-tag-menu-item-title">
                    Change method to:
                  </div>

                  <li
                    @click="updateDepMethod(method.id)"
                    class="assign-menu-item"
                    v-for="method in dictionaries.activity.deposit_methods"
                    :key="method.id"
                  >
                    {{ method.method }}
                  </li>
                  <li class="assign-menu-item" @click="showChangeMethod = null">
                    <span class="cancel-edit-menu-item"
                      >Cancel <span class="fas fa-times remove-tag-icon"></span
                    ></span>
                  </li>
                </ul>
              </td>

              <td style="position: relative">
                <!--      <template v-if="editMode">
                             <select
                                    class="deposit-select"
                                    v-model="deposit.status_id"
                                    @change="updateStatus(deposit,idx)"
                                  >
                                    <option
                                      v-for="status in checkPrivileges(statusList)"
                                      :key="status.id"
                                      :value="status.id"
                                      >{{ status.type }}</option
                                    >
                                  </select>
                                </template>-->

                <!--   <template v-else>{{ deposit.type.type }}</template>-->
                <span
                  @click="
                    showChangeStatus = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeUser = null;
                    showChangeBroker = null;
                    showChangeAmount = null;
                    showChangeDate = null;
                    showChangeCurrency = null;
                    showChangeComment = null;
                    showChangeMethod = null;
                    showChangeScheduleCall = null;
                  "
                  class="td-edit comment-p"
                  v-tooltip.bottom="{ content: deposit.type.type }"
                >
                  {{ deposit.type.type | truncate(6) }}
                  <!--                  <span-->
                  <!--                    :class="{ 'tool-comment': deposit.type.type.length >= 6 }"-->
                  <!--                  >-->
                  <!--                    {{ deposit.type.type }}-->
                  <!--                  </span>-->
                </span>
                <ul
                  v-if="showChangeStatus === deposit.id"
                  class="p-xy-8 status-dropdown-menu"
                >
                  <div class="add-tag-menu-item-title">
                    Change status to:
                  </div>

                  <li
                    @click="updateStatus(deposit, status.id)"
                    class="assign-menu-item"
                    v-for="status in checkPrivileges(statusList)"
                    :key="status.id"
                  >
                    {{ status.type }}
                  </li>
                  <li class="assign-menu-item" @click="showChangeStatus = null">
                    <span class="cancel-edit-menu-item"
                      >Cancel <span class="fas fa-times remove-tag-icon"></span
                    ></span>
                  </li>
                </ul>
                <div
                  v-if="showRemCommentBox === deposit.id"
                  class="p-xy-8 status-dropdown-menu removed-comment-box"
                >
                  <div class="add-tag-menu-item-title">
                    Type Removal reason to confirm
                  </div>
                  <span
                    ><textarea
                      class="form-control input-sm comment-box-scheduled "
                      v-model="remComment"
                      maxlength="160"
                      type="search"
                    />
                    <span class="text-counter-scheduled"
                      >{{ remComment.length }}/160</span
                    ></span
                  >
                  <br />
                  <span
                    class="apply-edit-menu-item"
                    @click="updateStatus(deposit, 4)"
                    >Apply</span
                  >
                  <span
                    class="cancel-edit-menu-item"
                    @click="showRemCommentBox = null"
                    >Cancel</span
                  >
                </div>
              </td>
              <td>
                <span
                  ><i
                    v-if="deposit.status_id == 4"
                    class="fas fa-info"
                    @click="
                      [(reasonRem = !reasonRem), (showReasonRem = deposit.id)]
                    "
                  ></i
                ></span>
                <div
                  v-if="reasonRem && showReasonRem == deposit.id"
                  class="reason-for-remove"
                  v-click-outside="closeReasonRem"
                >
                  <p>
                    <span class="trans-declined"> Deletion Reason: </span
                    >{{ deposit.rem_stat_comment }}
                  </p>
                </div>
              </td>
              <td>
                <span
                  class="td-edit"
                  v-if="deposit.comment && showChangeComment === null"
                  @click="
                    depIdToEdit = deposit.id;
                    showChangeComment = deposit.id;
                    showChangeMethod = null;
                    showChangeUser = null;
                    showChangeBroker = null;
                    showChangeAmount = null;
                    showChangeDate = null;
                    showChangeCurrency = null;
                    showChangeScheduleCall = null;
                  "
                  v-tooltip.bottom="{ content: deposit.comment }"
                  >{{ deposit.comment | truncate(15) }}</span
                >
                <span
                  class="td-edit"
                  v-if="deposit.comment === null && showChangeComment === null"
                  @click="
                    depIdToEdit = deposit.id;
                    showChangeComment = deposit.id;
                    showChangeMethod = null;
                    showChangeUser = null;
                    showChangeBroker = null;
                    showChangeAmount = null;
                    showChangeDate = null;
                    showChangeCurrency = null;
                    showChangeScheduleCall = null;
                  "
                  >no-com</span
                >
                <span
                  ><textarea
                    v-model="newComment"
                    v-if="showChangeComment === deposit.id"
                    type="search"
                    class="amount-select"/>

                  <span
                    v-if="showChangeComment === deposit.id"
                    @click="
                      showChangeComment = null;
                      depIdToEdit = null;
                    "
                    class="fas fa-times remove-tag-icon"
                  ></span
                ></span>
              </td>
              <td
                v-show="
                  requestForDate.tagName !== 'dp' ||
                    requestForDate.id !== deposit.id
                "
              >
                <span
                  @click="
                    showChangeScheduleCall = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeUser = null;
                    showChangeAmount = null;
                    showChangeCurrency = null;
                    showChangeBroker = null;
                    showChangeMethod = null;
                    showChangeComment = null;
                    showChangeStatus = null;
                    showChangeDate = null;
                  "
                  class="date-pic td-edit"
                >
                  <span v-if="deposit.call_broker_at !== null"
                    >{{ formatDate(deposit.call_broker_at) }}
                    <i
                      v-if="
                        requestForDate.date == null ||
                          requestForDate.time == null
                      "
                      class="fas fa-edit clickable"
                      @click="
                        [
                          sendVuexToCal(deposit),
                          (clickedOnDateChange = true),
                          (depositDate = false)
                        ]
                      "
                    ></i>
                    <i
                      @click="sendNewDateFromPopUpToDB"
                      class="fas fa-check pointer"
                      v-if="
                        requestForDate.date != null &&
                          requestForDate.time != null &&
                          requestForDate.id === deposit.id
                      "
                    ></i>
                  </span>

                  <span v-else
                    >SC
                    <i
                      v-if="
                        requestForDate.date == null ||
                          requestForDate.time == null
                      "
                      class="fas fa-edit clickable "
                      @click="
                        [
                          sendVuexToCal(deposit),
                          (clickedOnDateChange = true),
                          (depositDate = false)
                        ]
                      "
                    ></i>
                    <i
                      @click="sendNewDateFromPopUpToDB"
                      class="fas fa-check pointer"
                      v-if="
                        requestForDate.date != null &&
                          requestForDate.time != null &&
                          requestForDate.id === deposit.id
                      "
                    ></i>
                  </span>
                </span>
                <!--                <div-->
                <!--                  v-if="showChangeScheduleCall === deposit.id"-->
                <!--                  class="date-dropdown-menu-broker-call"-->
                <!--                >-->
                <!--&lt;!&ndash;                  <date-picker&ndash;&gt;-->
                <!--&lt;!&ndash;                    v-model="newScheduledCallBrokerDate"&ndash;&gt;-->
                <!--&lt;!&ndash;                    :first-day-of-week="1"&ndash;&gt;-->
                <!--&lt;!&ndash;                    type="datetime"&ndash;&gt;-->
                <!--&lt;!&ndash;                    :minute-step="1"&ndash;&gt;-->
                <!--&lt;!&ndash;                    :time-picker-options="timePickerOptions"&ndash;&gt;-->
                <!--&lt;!&ndash;                    input-class="form-control input-date"&ndash;&gt;-->
                <!--&lt;!&ndash;                    :confirm="true"&ndash;&gt;-->
                <!--&lt;!&ndash;                    lang="en"&ndash;&gt;-->
                <!--&lt;!&ndash;                    @confirm="updateDepScheduledCallDate"&ndash;&gt;-->
                <!--&lt;!&ndash;                    class="form-control input-sm"&ndash;&gt;-->
                <!--&lt;!&ndash;                    inline&ndash;&gt;-->
                <!--&lt;!&ndash;                  ></date-picker>&ndash;&gt;-->
                <!--                  <span-->
                <!--                    v-if="showChangeScheduleCall === deposit.id"-->
                <!--                    @click="-->
                <!--                      showChangeScheduleCall = null;-->
                <!--                      depIdToEdit = null;-->
                <!--                    "-->
                <!--                    class="fas fa-times remove-tag-icon"-->
                <!--                  ></span>-->
                <!--                </div>-->
              </td>
              <td
                v-show="
                  requestForDate &&
                    requestForDate.tagName === 'dp' &&
                    requestForDate.id === deposit.id
                "
                :class="{ 'text-danger': !depositDate }"
              >
                <i
                  v-if="
                    (requestForDate.date == null ||
                      requestForDate.time == null) &&
                      !depositDate
                  "
                  class="fas fa-window-close clickable "
                  @click="[sendVuexToCal(), (clickedOnDateChange = true)]"
                ></i>
                <span v-else>{{ formatDateTable(deposit.created_at) }} </span>
                <i
                  @click="sendNewDateFromPopUpToDB"
                  class="fas fa-check pointer "
                  v-if="
                    requestForDate.date != null &&
                      requestForDate.time != null &&
                      requestForDate.id === deposit.id &&
                      !depositDate
                  "
                ></i>

                <span v-if="!depositDate">{{ textOrDate }}</span>
              </td>
              <td>
                <span
                  class="show-spec-btn"
                  @click="showHistoryByDepId(deposit.id)"
                  >{{ deposit.id }}</span
                ><span
                  v-if="showResetCloseHistory && depIdToEdit === deposit.id"
                  @click="clearHistorySelection()"
                  class="fas fa-times remove-tag-icon"
                ></span>
              </td>
              <td v-if="checkPermissions(auth, [1, 2, 3, 4, 12])">
                {{ checkDepositConversionTime(deposit.id) }}
              </td>

              <td>
                <span
                  v-if="
                    deposit.status_id !== 4 &&
                      deposit.status_id !== 6 &&
                      deposit.status_id !== 5
                  "
                  class="trans-approved-before"
                >
                  <i class="fas fa-check"></i>
                </span>
                <span v-if="deposit.status_id === 5" class="trans-approved">
                  <i class="fas fa-check"></i>
                </span>
                <span
                  v-if="deposit.status_id === 4 || deposit.status_id === 6"
                  class="trans-declined"
                >
                  <i class="fas fa-times"></i>
                </span>
              </td>

              <td>
                <div class="floating-wrapper">
                  <TaskForm :deposit="deposit" @task="newTask"></TaskForm>
                </div>
              </td>
              <td>
                <span
                  v-if="deposit.second_user"
                  @click="
                    showChangeSecondUser = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeBroker = null;
                    showChangeAmount = null;
                    showChangeCurrency = null;
                    showChangeDate = null;
                    showChangeMethod = null;
                    showChangeComment = null;
                    showChangeStatus = null;
                    showChangeScheduleCall = null;
                  "
                  class="td-edit"
                  >{{ deposit.second_user.full_name }}</span
                >
                <span
                  v-if="!deposit.second_user"
                  @click="
                    showChangeSecondUser = deposit.id;
                    depIdToEdit = deposit.id;
                    showChangeBroker = null;
                    showChangeAmount = null;
                    showChangeCurrency = null;
                    showChangeDate = null;
                    showChangeMethod = null;
                    showChangeComment = null;
                    showChangeStatus = null;
                    showChangeScheduleCall = null;
                  "
                  ><i class="fas fa-plus"></i
                ></span>
                <ul
                  v-if="
                    showChangeSecondUser === deposit.id &&
                      checkPermissions(auth, [1, 2, 3, 4, 5, 6, 7, 8])
                  "
                  class="p-xy-8 user-dropdown-menu second-deposit-dropdown"
                >
                  <li
                    class="assign-menu-item"
                    @click="showChangeSecondUser = null"
                  >
                    <span class="cancel-edit-menu-item"
                      >Cancel <span class="fas fa-times remove-tag-icon"></span
                    ></span>
                  </li>
                  <div class="add-tag-menu-item-title">
                    Add 2nd User:
                  </div>
                  <li
                    @click="updateSecondDepUser(person.id)"
                    class="assign-menu-item"
                    v-for="person in salesPersonList"
                    :key="person.id"
                    v-tooltip.bottom="{
                      content: person.first_name + ' ' + person.last_name
                    }"
                  >
                    {{
                      (person.first_name + " " + person.last_name)
                        | truncate(15)
                    }}
                  </li>
                </ul>
              </td>
              <!--              CHECK IF HAS NA BEFORE DEPOSIT-->
              <td
                v-if="
                  client_dep.hasOwnProperty('na') && client_dep.na.length > 0
                "
              >
                {{
                  getDiffByTimes(
                    client_dep.na[client_dep.na.length - 1].created_at,
                    deposit.updated_at
                  ).toUpperCase()
                }}
              </td>
              <!--              CHECK IF HAS SC BEFORE DEPOSIT-->
              <td
                v-if="
                  client_dep.hasOwnProperty('scheduled_calls') &&
                    client_dep.scheduled_calls.length > 0
                "
              >
                {{
                  getDiffByTimes(
                    client_dep.scheduled_calls[
                      client_dep.scheduled_calls.length - 1
                    ].scheduled_on,
                    deposit.updated_at
                  ).toUpperCase()
                }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div class="for-history-btn">
          <button
            v-if="log.length > 0"
            @click="showHistory = !showHistory"
            class="history-btn"
          >
            {{ showHistory ? "Hide History" : "Show History" }}
          </button>

          <loader
            class="spinner-bottom-ms"
            v-if="showSpinner"
            :size="'3px'"
          ></loader>
        </div>

        <div v-if="showHistory">
          <div class="table-history">
            <table class="table ">
              <thead>
                <tr>
                  <th class="t-header">DATE</th>
                  <th class="t-header">TIME</th>
                  <th class="t-header">AGENT</th>
                  <th class="t-header">BROKER</th>
                  <th class="t-header">AM</th>
                  <th class="t-header">
                    <i class="fas fa-pound-sign"></i
                    ><i class="fas fa-dollar-sign"></i
                    ><i class="fas fa-euro-sign"></i>
                  </th>
                  <th class="t-header">METHOD</th>
                  <th class="t-header">TYPE</th>
                  <th class="t-header">COMM</th>
                  <th class="t-header">UPDATED BY</th>
                  <th class="t-header">ID</th>
                  <th class="t-header">STAT</th>
                  <th class="t-header">
                    <i
                      class="fa fa-times"
                      aria-hidden="true"
                      @click="
                        [
                          (editMode = false),
                          (showTodaysDeposits = false),
                          endHover,
                          selectedDepTab === 'QUESTIONS' ||
                          selectedDepTab === 'SUPPORT'
                            ? (clickedOnDateChange = false)
                            : ''
                        ]
                      "
                    ></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(deposit, idx) in depLog" :key="idx">
                  <td>{{ formatDateTable(deposit.created_at) }}</td>
                  <td>{{ deposit.created_at | shortTime }}</td>
                  <td>{{ deposit.user.full_name }}</td>
                  <td class="for-broker-name">{{ deposit.campaign.name }}</td>
                  <td class="text-right">{{ deposit.amount }}</td>
                  <td class="text-right for-symbol">
                    <span v-if="deposit.currency">{{
                      deposit.currency.symbol
                    }}</span>
                  </td>
                  <td class="text-right for-methods">
                    <span v-if="deposit.method">{{
                      deposit.method.method
                    }}</span>
                  </td>
                  <td>{{ deposit.type.type }}</td>
                  <td>
                    <span
                      v-if="deposit.comment"
                      v-tooltip.bottom="{ content: deposit.comment }"
                    >
                      {{ deposit.comment | truncate(15) }}
                    </span>
                  </td>
                  <td>
                    <span v-if="deposit.updated_by">{{
                      deposit.updated_by.full_name
                    }}</span>
                  </td>

                  <td>{{ deposit.deposit_id }}</td>

                  <td>
                    <span
                      v-if="
                        deposit.status_id !== 4 &&
                          deposit.status_id !== 6 &&
                          deposit.status_id !== 5
                      "
                      class="trans-approved-before"
                    >
                      <i class="fas fa-check"></i>
                    </span>
                    <span v-if="deposit.status_id === 5" class="trans-approved">
                      <i class="fas fa-check"></i>
                    </span>
                    <span
                      v-if="deposit.status_id === 4 || deposit.status_id === 6"
                      class="trans-declined"
                    >
                      <i class="fas fa-times"></i>
                    </span>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="showAnswersHistory && selectedDepTab === 'SUPPORT'">
        <div class="table-history">
          <table class="table ">
            <tbody>
              <tr v-for="(answer, idx) in ansLog" :key="idx">
                <td>{{ formatDateTable(answer.created_at) }}</td>
                <td>{{ answer.created_at | shortTime }}</td>
                <td>{{ answer.user.full_name }}</td>
                <td>{{ answer.question.title }}</td>
                <td>
                  <span v-if="answer.answer_confirm !== 0">
                    <img width="21" src="/img/icons/correct.svg"/></span
                  ><span v-else>
                    <img width="21" src="/img/icons/close.svg"
                  /></span>
                </td>
                <td>###</td>
                <td>{{ answer.deposit_id }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="selectedDepTab === 'QUESTIONS'">
        <table class="table question-table">
          <tbody>
            <tr>
              <th
                v-for="id in questLog"
                :key="id"

              >
                <span v-tooltip.bottom="{ content: id.question }">{{ id.question | truncate(16) }}</span>
              </th>
              <th>
                STATUS
              </th>
              <th>
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @click="
                    [
                      (editMode = false),
                      (showTodaysDeposits = false),
                      endHover,
                      selectedDepTab === 'QUESTIONS' ||
                      selectedDepTab === 'SUPPORT'
                        ? (clickedOnDateChange = false)
                        : ''
                    ]
                  "
                ></i>
              </th>
            </tr>
            <tr>
              <td v-for="id in questLog" :key="id">
                <client-answer
                  :client="client_dep"
                  :question-id="id.id"
                  :root="'depositTag'"
                  @updated="updateClients"
                >
                </client-answer>
              </td>
              <td class="center-td">
                <dot-indicator :client="client_dep"> </dot-indicator>
              </td>
            </tr>
            <th></th>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "../../../../../../helpers/api/request";
import DepositAnswer from "../support_deposits_questioner/DepositAnswer.component";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import DepDotIndicator from "../support_deposits_questioner/DepDotIndicator.component";
import DotIndicator from "../questioner/DotIndicator.component";
import TaskForm from "../../../../../tasks.feature/components/ExternalTaskRequestForm.component";
import Loader from "../../../../../../main/misc.main/loader/Loader";
import vClickOutside from "v-click-outside";
import SelectComponent from "./SelectComponent";
import ClientAnswer from "../questioner/ClientAnswer.component";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";
import GetDateTitles from "@/mixins/tags/GetDateTitles";
import getDiffInTime from "../../../../../../mixins/util/getDiffInTime";

export default {
  name: "deposits",
  components: {
    Loader,
    SelectComponent,
    // DatePicker,
    DepositAnswer,
    DepDotIndicator,
    DotIndicator,
    TaskForm,
    ClientAnswer
  },
  mixins: [calendarCheck, getDiffInTime],
  props: {
    sendUpdated: {
      type: Boolean,
      required: true
    },
    deposits: {
      type: Array,
      required: true
    },
    client_dep: {
      type: Object,
      required: true
    },
    statusList: {
      type: Array,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    },
    log: {
      type: Array,
      required: true
    },
    answers: {
      type: Object
    },

    answersLog: {
      type: Array
    },

    country: {
      type: Object,
      required: true
    },
    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },
    queryObject: {
      type: Object
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      depLog: this.log,
      ansLog: this.answersLog,
      showTable: false,
      showResetCloseHistory: null,
      showResetCloseAnswerHistory: null,
      showHistory: false,
      showAnswersHistory: false,
      editMode: false,
      showInfoIcon: false,
      showTodaysDeposits: false,
      showChangeUser: null,
      showChangeSecondUser: null,
      showChangeBroker: null,
      showChangeAmount: null,
      showChangeComment: null,
      showChangeCurrency: null,
      showChangeDate: null,
      showChangeScheduleCall: null,
      showChangeMethod: null,
      showChangeStatus: null,
      showSpinner: false,
      depIdToEdit: null,
      ansIdToEdit: null,
      newAmount: "",
      newCurrency: "",
      newDate: "",
      newScheduledCallBrokerDate: "",
      newComment: "",
      remComment: "",
      showRemCommentBox: null,
      forChoose: true,
      docChoosed: false,
      selectedDepTab: "BROKER",
      depTabs: [
        {
          id: 1,
          name: "BROKER",
          alias: "BROKER"
        },
        {
          id: 2,
          name: "SUPPORT",
          alias: "SUPPORT"
        },
        {
          id: 3,
          name: "QUESTIONS",
          alias: "QUESTIONS"
        }
      ],
      questLog: [
        {
          id: 1,
          question: "Occupation"
        },
        {
          id: 2,
          question: "What Signals?"
        },
        {
          id: 3,
          question: "Trading Time"
        },
        {
          id: 4,
          question: "Invested So Far"
        },
        {
          id: 5,
          question: "How Much Profit Expected?"
        },
        {
          id: 6,
          question: "Plan To Invest?"
        },
        {
          id: 7,
          question: "Amount Of Broker Or Names"
        },
        {
          id: 8,
          question: "Amount Of Signals?"
        },
        {
          id: 9,
          question: "Reason for trading"
        },
        {
          id: 10,
          question: "Originaly From"
        },
        {
          id: 11,
          question: "Age"
        }
      ],
      timePickerOptions: {
        start: "00:00",
        step: "00:15",
        end: "23:45"
      },
      selectedMethodTypes: ["Phone", "Email", "Skype", "WhatsApp"],
      reasonRem: false,
      showReasonRem: null,
      textOrDate: "Choose date",
      totalBrokerTimeAfterChange: null,
      depositDate: false,
      clickedOnDateChange: false,
      recId: null,
      tagName: null,
      newHours: null,
      total: null
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "timer",
      "requestForDate",
      "openedTabTag"
    ]),
    ...mapGetters("clients", ["timeStart"])
  },
  created() {},
  watch: {
    openedTabTag: function() {
      if (
        this.openedTabTag.cmd === "close" &&
        this.openedTabTag.clientId !== this.client_dep.id
      ) {
        this.editMode = false;
      }
    },

    editMode: function() {
      if (this.editMode === false) {
        this.$store.commit("clients/setOpenedTabTag", {
          tagName: null,
          clientId: null,
          cmd: null
        });
      }
    },

    selectedDepTab: function() {
      if (
        this.selectedDepTab === "QUESTIONS" ||
        this.selectedDepTab === "SUPPORT"
      ) {
        this.clickedOnDateChange = true;
      }
    },
    requestForDate: function() {
      if (this.requestForDate.time != null) {
        this.textOrDate =
          this.requestForDate.date + " " + this.requestForDate.time;
        // this.editMode = true;
      }
      if (this.requestForDate.date != null) {
        this.textOrDate = this.requestForDate.date;
      }
      if (
        this.requestForDate.direction === "FROM_CAL" &&
        this.requestForDate.id === this.editId &&
        this.requestForDate.tagName === "dp"
      ) {
        this.recId = this.requestForDate.id;
        this.tagName = this.requestForDate.tagName;
        this.newDate = this.requestForDate.date;
        this.newHours = this.requestForDate.time;
        this.total = moment(
          `${this.newDate} ${this.newHours}`,
          "YYYY-MM-DD HH:mm:ss"
        ).format("YYYY-MM-DD HH:mm:ss");
        this.totalBrokerTimeAfterChange = this.total;
        // console.log(total._i);
        this.editId = null;

        // const apiUpdatedDate = apiClientCreator(
        //         `client/updatedDateFromPopUp/${clientId}`
        // );
        // apiUpdatedDate
        //         .post("", {
        //           updated_date: newDate,
        //           updated_date_hours : newHours,
        //           tag_name:tagName
        //         })
        //         .then(e => {
        //           this.$emit("updated");
        //         });
      }
    },
    initiatedFiltering: function() {
      if (this.initiatedFiltering) {
        ///  console.log(this.queryObject)
      }
    },
    queryObject: function() {}
  },
  mounted() {
    // console.log(this.client_dep.calls_log[0].created_at);
  },
  methods: {
    clickedForOpenPopUp() {
      if (this.openedTabTag.clientId !== this.client_dep.id) {
        //&& (this.openedTabTag.tagName !== 'dp')
        this.$store.commit("clients/setOpenedTabTag", {
          tagName: "dp",
          clientId: this.client_dep.id,
          cmd: "close"
        });
        this.editMode = true;
      }
    },
    sendNewDateFromPopUpToDB() {
      if (!this.depositDate) {
        this.updateDepScheduledCallDate();
      } else {
        this.updateDepDate();
      }
    },
    sendVuexToCal(dep = null) {
      if (dep) {
        this.editId = dep.id;
        this.$store.commit("clients/setRequestForDate", {
          tagName: "dp",
          fromWhere: "deposits",
          calendar: "DEP",
          id: dep.id,
          client_id: this.client_dep.id,
          direction: "FROM_TAG"
        });
      } else {
        this.$store.commit("clients/setRequestForDate", {});
      }
    },
    checkSelectedCalDates(depDit) {
      // console.log(this.queryObject)
      // console.log(depDit)

      let depIn = moment(depDit.created_at);
      let start = moment(this.queryObject.deposit_at_from).startOf("day");
      let to = moment(this.queryObject.deposit_at_to).endOf("day");
      // console.log(depIn+ " "+ "dep");
      // console.log(start+ " "+ "start");
      // console.log(to+ " "+ "to");
      if (depIn.isBetween(start, to)) {
        return true;
      } else {
        return false;
      }
    },
    // fillterMain() {
    //   this.$store.commit("clients/setFilterToMain", {
    //     title: "dep",
    //     type: true
    //   });
    // },
    closeReasonRem() {
      this.reasonRem = false;
    },
    tag_deposit_back_to_sale() {
      let backToSales = this.deposits.some(user => user.status_id === 9);

      if (backToSales) {
        return "tag-deposit-for-back-to-sales table-tag-content";
      } else {
        return "tag-deposit table-tag-content";
      }
    },
    updateClients() {
      this.$emit("updated");
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    openDocInNewWindow(url) {
      window.open(url, "_blank");
    },
    matchedAnswer(id) {
      return this.answers.contact_at.find(answer => answer.deposit_id === id);
    },
    checkTodayDepositsMixed() {
      const find_cc_rem = this.checkTodaysDeposits().find(
        item => item.status_id === 6 || item.status_id === 4
      );
      // const find_rem = this.checkTodaysDeposits().find(item => item.status_id === 4)
      const find_other = this.checkTodaysDeposits().find(
        item => item.status_id !== 4 && item.status_id !== 6
      );
      if (find_cc_rem !== undefined && find_other === undefined) {
        return "tag-deposit-today-cc table-tag-content";
      }
      // if (find_cc_rem !== undefined && find_other !== undefined) {
      if (find_cc_rem && find_other) {
        return "tag-deposit-overlay ";
      }
      if (find_cc_rem === undefined && find_other !== undefined) {
        return "tag-deposit-today ";
      }
    },
    checkLength(arr) {
      if (arr.length > 0) {
        return arr.filter(item => item.status_id !== 6 && item.status_id !== 4);
      }
    },
    checkPrivileges(data) {
      if (this.checkPermissions(this.auth, [1, 2, 3, 4, 12])) {
        return data;
      }
      return data.filter(
        item => item.id !== 4 && item.id !== 7 && item.id !== 5
      );
    },

    checkPrivilegesTable(data) {
      return data;
    },
    async updateDepDate() {
      this.showSpinner = true;
      let apiClient = apiClientCreator("client/deposit-status/" + this.recId);
      await apiClient.put("", { created_at: this.totalBrokerTimeAfterChange });
      this.$emit("updated");
      this.clickedOnDateChange = false;
      this.recId = null;
      this.editMode = false;
      this.totalBrokerTimeAfterChange = null;
      this.showChangeDate = false;
      this.showSpinner = false;
      this.depositDate = false; // exit the mode by set as False as initiated
      this.$store.commit("clients/setRequestForDate", {});
    },

    async updateDepScheduledCallDate() {
      this.showSpinner = true;
      let apiClient = apiClientCreator(
        "client/deposit-status/" + this.recId
        // "client/deposit-status/" + this.depIdToEdit
      );
      await apiClient.put("", {
        call_broker_at: this.totalBrokerTimeAfterChange
      });
      this.$emit("updated");
      this.clickedOnDateChange = false;
      this.recId = null;
      this.editMode = false;
      this.totalBrokerTimeAfterChange = null;
      this.showChangeScheduleCall = false;
      this.showSpinner = false;
      this.$store.commit("clients/setRequestForDate", {});
    },

    async updateDepCurrecy(currId) {
      this.showSpinner = true;
      let apiClient = apiClientCreator(
        "client/deposit-status/" + this.depIdToEdit
      );
      await apiClient.put("", { currency_id: currId });
      this.$emit("updated");
      this.depIdToEdit = null;
      this.showChangeCurrency = false;
      this.newDate = null;
      this.newCurrency = null;
      this.showSpinner = false;
    },

    async updateDepMethod(methodId) {
      this.showSpinner = true;
      let apiClient = apiClientCreator(
        "client/deposit-status/" + this.depIdToEdit
      );
      await apiClient.put("", { method_id: methodId });
      this.$emit("updated");
      this.depIdToEdit = null;
      this.showChangeMethod = false;
      this.newDate = null;
      this.newCurrency = null;
      this.showSpinner = false;
    },

    async updateDepAmount() {
      if (this.newAmount.length > 1) {
        this.showSpinner = true;
        let apiClient = apiClientCreator(
          "client/deposit-status/" + this.depIdToEdit
        );
        await apiClient.put("", { amount: this.newAmount });
        this.$emit("updated");
        this.depIdToEdit = null;
        this.showChangeAmount = false;
        this.newAmount = "";

        //  this.editMode = false;
        this.showSpinner = false;
      }
    },

    async updateDepComment() {
      if (this.newComment.length > 1) {
        this.showSpinner = true;
        let apiClient = apiClientCreator(
          "client/deposit-status/" + this.depIdToEdit
        );
        await apiClient.put("", { comment: this.newComment });
        this.$emit("updated");
        this.newComment = "";
        this.depIdToEdit = null;
        this.showChangeComment = null;
        this.newAmount = "";
        this.showSpinner = false;
      }
    },
    async updateDepBroker(brokerId) {
      this.showSpinner = true;
      let apiClient = apiClientCreator(
        "client/deposit-status/" + this.depIdToEdit
      );
      await apiClient.put("", { broker_id: brokerId });
      this.$emit("updated");
      this.depIdToEdit = null;
      this.showChangeBroker = false;
      this.newDate = null;
      this.showSpinner = false;
    },

    async updateDepUser(userId) {
      this.showSpinner = true;
      let apiClient = apiClientCreator(
        "client/deposit-status/" + this.depIdToEdit
      );
      await apiClient.put("", { user_id: userId });
      this.$emit("updated");
      this.depIdToEdit = null;
      this.showChangeUser = false;
      this.showSpinner = false;
    },

    async updateSecondDepUser(secUserId) {
      this.showSpinner = true;
      let apiClient = apiClientCreator(
        "client/deposit-status/" + this.depIdToEdit
      );
      await apiClient.put("", { sec_user_id: secUserId });
      this.$emit("updated");
      this.depIdToEdit = null;
      this.showChangeSecondUser = false;
      this.showSpinner = false;
    },

    async updateStatus(deposit, statusId) {

      const prevStatus = this.log.find(item => item.deposit_id === deposit.id)
        .status_id;
      const newStatus = statusId;
      this.showSpinner = true;

      const data = { status_id: statusId };
      if (prevStatus !== 4 && prevStatus !== 6 && newStatus === 4) {
        if (this.remComment.length === 0) {
          this.showSpinner = false;
          this.showChangeStatus = null;
          return (this.showRemCommentBox = deposit.id);
        } else if (this.remComment.length > 0 && this.remComment.length < 10) {
          return this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Your comment for the Removed deposit status too short - min 10 chars",
            type: "WARNING",
            op: { type: "SYSTEM" }
          });
        }
        Object.assign(data, { rem_stat_comment: this.remComment });
      }

      let apiClient = apiClientCreator(
        "client/deposit-status/" + this.depIdToEdit
      );

      apiClient
        .put("", data)
        .then(res => {
          this.$emit("updated");
          this.showSpinner = false;
          this.showChangeStatus = null;

          this.showRemCommentBox = null;
          this.remComment = "";

          this.$store.commit("clients/setUpdateDepCharts", true);

          if (
            (prevStatus === 4 || prevStatus === 6) &&
            (newStatus !== 4 && newStatus !== 6)
          ) {
            this.sendSMSAfterDepRequest(deposit, res.data);
          }
          if (prevStatus !== 4 && prevStatus !== 6 && newStatus === 4) {
            this.sendSMSAfterDepRemovalRequest(deposit, res.data);
          }
          if (prevStatus !== 4 && prevStatus !== 6 && newStatus === 6) {
            this.$store.dispatch("clients/startTheTimer", true);
          }
        })
        .catch(e => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Deposit Status Change Error!" +
              " " +
              " Error Status: " +
              e.response.status,
            type: "ERROR",
            op: { type: "SYSTEM" }
          });
          this.$store.commit("clients/setLoading", false);
        });
    },

    closeEdit() {
      if (event.target.hasOwnProperty("parentNode")) {
        if (
          event.target.parentNode.className == "cell active" ||
          event.target.parentNode.className == "cell today active"
        ) {
        } else {
          if (
            !this.showChangeBroker &&
            !this.showChangeUser &&
            !this.showChangeAmount &&
            !this.showChangeDate &&
            !this.showChangeComment &&
            this.requestForDate.direction !== "FROM_TAG" &&
            this.requestForDate.id !== this.editId &&
            this.requestForDate.date == null &&
            this.requestForDate.time == null
          )
            // this.editMode = false;
            this.showInfoIcon = false;
        }
      }
    },

    showHistoryByDepId(id) {
      this.showResetCloseHistory = true;
      this.depIdToEdit = id;
      this.depLog = this.log.filter(item => item.deposit_id === id);
      this.showHistory = true;
    },

    showBrokerByAnsDepId(id) {
      return this.deposits.filter(item => item.id === id);
    },

    showAnswerHistoryByDepId(id) {
      this.showResetCloseAnswerHistory = true;
      this.ansIdToEdit = id;
      this.ansLog = this.answersLog.filter(item => item.deposit_id === id);
      this.showAnswersHistory = true;
    },

    clearHistorySelection() {
      this.showResetCloseHistory = false;
      this.depIdToEdit = null;
      this.depLog = this.log;
      this.showHistory = false;
    },
    clearAnswersHistorySelection() {
      this.showResetCloseAnswerHistory = false;
      this.ansIdToEdit = null;
      this.ansLog = this.answersLog;
      this.showAnswersHistory = false;
    },

    checkTodaysDepositsCCREM() {
      return this.checkTodaysDeposits().filter(
        item => item.status_id === 6 || item.status_id === 4
      );
    },

    // //function for showing choco-vanila without a date pick//
    // checkTodaysDepositsCCREM() {
    //   return this.deposits.filter(
    //           item => item.status_id === 6 || item.status_id === 4
    //   );
    // },

    checkBrokersCountTwice(depArr) {
      const brokers = this.dictionaries.general.brokers;
      const countTwice = brokers.filter(broker => broker.count_twice !== 1);
      let freq = 0;
      depArr.forEach(dep => {
        freq++;
        const check = countTwice.some(broker => {
          return broker.id === dep.campaign_id;
        });

        if (check && dep.amount === 1000) {
          freq++;
        }
      });
      return freq;
    },

    checkTodaysDepositsRegular() {
      this.checkBrokersCountTwice(this.checkTodaysDeposits());
      return this.checkTodaysDeposits().filter(
        item => item.status_id !== 4 && item.status_id !== 6
      );
    },

    //
    // //function for showing choco-vanila without a date pick//
    // checkTodaysDepositsRegular() {
    //   this.checkBrokersCountTwice(this.checkTodaysDeposits());
    //   return this.deposits.filter(
    //           item => item.status_id !== 4 && item.status_id !== 6
    //   );
    // },
    checkDepositConversionTime(depositId) {
      let startCount, endCount;
      const log = this.log.filter(item => item.deposit_id === depositId);
      const revered = log.slice().reverse();
      if (revered.length > 1 && revered[0].status_id === 6) {
        startCount = moment(revered[0].created_at);
        endCount = moment(revered[1].created_at);
        const duration = moment.duration(endCount.diff(startCount));
        if (duration._data.days > 0) {
          return duration._data.days + "d";
        } else {
          if (duration._data.hours > 0) {
            return duration._data.hours + "h";
          } else {
            return duration._data.minutes + "m";
          }
        }
        //  return 77
        // var hours = duration.asHours();
      }
    },

    checkTodaysDeposits() {
      let dep;
      let dep1;
      // if (this.queryObject.deposit_at_from === undefined) {
      //
      //   dep = this.deposits.filter(
      //     dep => moment().isAfter(dep.created_at, "day") === false
      //   );
      // } else {
      dep = this.deposits.filter(deps => {
        const from = moment(this.queryObject.deposit_at_from).format(
          "YYYY-MM-DD"
        );
        const to = moment(this.queryObject.deposit_at_to).format("YYYY-MM-DD");
        const createdAt = moment(deps.created_at).format("YYYY-MM-DD");

        if (
          moment(from).isSame(createdAt) === true &&
          moment(from).isSame(to) === true
        ) {
          return moment(from).isSame(createdAt) === true;
        }

        if (moment(from).isSame(to) === false) {
          return (
            moment(from).isAfter(createdAt, "day") === false &&
            moment(to).isBefore(createdAt, "day") === false
          );
        }
      });
      // }

      let newDep = [];
      if (
        this.queryObject.deposit_statuses.length > 0 ||
        this.queryObject.deposit_brokers.length > 0 ||
        this.queryObject.deposit_users.length > 0 ||
        this.queryObject.deposit_sec_users.length > 0 ||
        this.queryObject.deposit_brokers_quantity.length > 0
      ) {
        if (this.queryObject.deposit_statuses.length > 0) {
          this.queryObject.deposit_statuses.forEach(
            element =>
              (newDep = [
                ...newDep,
                ...dep.filter(item => item.status_id === element)
              ])
          );
        }
        if (this.queryObject.deposit_brokers.length > 0) {
          this.queryObject.deposit_brokers.forEach(
            element =>
              (newDep = [
                ...newDep,
                ...dep.filter(item => item.campaign_id === element)
              ])
          );
        }
        if (this.queryObject.deposit_users.length > 0) {
          this.queryObject.deposit_users.forEach(
            element =>
              (newDep = [
                ...newDep,
                ...dep.filter(item => item.user_id === element)
              ])
          );
        }
        if (this.queryObject.deposit_sec_users.length > 0) {
          this.queryObject.deposit_sec_users.forEach(
            element =>
              (newDep = [
                ...newDep,
                ...dep.filter(item => item.sec_user_id === element)
              ])
          );
        }
        if (this.queryObject.deposit_brokers_quantity.length > 0) {
          return dep;
        }
        return Array.from(new Set(newDep.map(a => a.id))).map(id => {
          return newDep.find(a => a.id === id);
        });
      } else {
        return dep;
      }
    },

    getDayTime() {
      const format = "hh:mm:ss";
      const time = moment();
      const morningStart = moment("05:01:00", format);
      const morningEnd = moment("11:00:00", format);
      const afternoonStart = moment("11:01:00", format);
      const afternoonEnd = moment("16:00:00", format);
      const eveningStart = moment("16:01:00", format);
      const eveningEnd = moment("22:00:00", format);
      const nightStart = moment("22:01:00", format);
      const nightEnd = moment("23:59:00", format);
      const nightStart2 = moment("00:00:00", format);
      const nightEnd2 = moment("05:59:00", format);

      if (time.isBetween(morningStart, morningEnd)) {
        return "Good Morning";
      }

      if (time.isBetween(afternoonStart, afternoonEnd)) {
        return "Good Afternoon";
      }

      if (time.isBetween(eveningStart, eveningEnd)) {
        return "Good Evening";
      }

      if (
        time.isBetween(nightStart, nightEnd) ||
        time.isBetween(nightStart2, nightEnd2)
      ) {
        return "Good Night";
      }
    },

    findBrokerNameByID(brokerId) {
      return this.dictionaries.general.brokers.find(
        item => item.id === brokerId
      ).name;
    },
    findBrokerEmailByID(brokerId) {
      return this.dictionaries.general.brokers.find(
        item => item.id === brokerId
      ).support_email;
    },
    findCurrencySymbolByID(curId) {
      return this.dictionaries.activity.currency_types.find(
        item => item.id === curId
      ).symbol;
    },
    sendSMSAfterDepRequest(data) {
      const sendSMSReq = apiClientCreator(
        `client/sms/deposit/send/${data.client_id}`
      );
      sendSMSReq.post("", {
        day_time: this.getDayTime(),
        user_id: data.user_id,
        message:
          "  did a New Deposit: " +
          this.formatDate(moment()) +
          " | " +
          this.country.name +
          " | " +
          data.amount +
          this.findCurrencySymbolByID(data.currency_id) +
          " | " +
          this.findBrokerNameByID(data.campaign_id) +
          " | " +
          " #" +
          data.client_id
      });

      /*              .catch(e =>{
                                    this.$store.commit("main/setShowVikiMsg", {
                                      show: true,
                                      msg: "Sent SMS To Client Error " + e.response.status,
                                      type: "ERROR"
                                    });
                                    this.$store.commit("clients/setLoading", false);
                                  })*/
    },
    sendSMSAfterDepRemovalRequest(data) {
      const sendSMSReq = apiClientCreator(
        `client/sms/deposit/send/${data.client_id}`
      );
      sendSMSReq.post("", {
        day_time: this.getDayTime(),
        user_id: data.user_id,
        message:
          "  Removed Deposit: " +
          this.formatDate(moment()) +
          " | " +
          this.country.name +
          " | " +
          data.amount +
          this.findCurrencySymbolByID(data.currency_id) +
          " | " +
          this.findBrokerNameByID(data.campaign_id) +
          " | " +
          " #" +
          data.client_id
      });

      /*              .catch(e =>{
                                    this.$store.commit("main/setShowVikiMsg", {
                                      show: true,
                                      msg: "Sent SMS To Client Error " + e.response.status,
                                      type: "ERROR"
                                    });
                                    this.$store.commit("clients/setLoading", false);
                                  })*/
    },
    endHover() {
      if (!this.editMode) {
        this.showInfoIcon = false;
      }
    },
    formatDateLc(date) {
      let duration = moment.duration(moment().diff(date));
      duration = duration.humanize();

      if (duration.includes("an")) {
        duration = duration.replace("an", "1 ");
      }
      if (duration.includes("a y")) {
        duration = duration.replace("a ", "1 ");
      }
      if (duration.includes("a d")) {
        duration = duration.replace("a ", "1 ");
      }
      return duration;
    },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YYYY");
    },
    newTask(task) {
      this.$emit("task", task);
    },
    async uploadFileImage(id, e) {
      this.showSpinner = true;
      this.forChoose = false;

      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);

      const formData = new FormData();
      formData.append("con_file", image);
      const apiClient = apiClientCreator(
        `client/support/deposit/answer/upload/${id}`
      );
      await apiClient.post("", formData).then(res => {
        this.$emit("updated");
      });
      this.forChoose = false;
      this.showSpinner = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.center-td {
  display: flex;
  justify-content: center;
}
.tag-wrapper {
  display: inline-flex;
  position: relative;
  /*min-width: 164px !important;*/
}

.floating-wrapper {
  position: relative;
}

.absolute-wrapper {
  position: absolute;
}

.tag-deposit {
  background-color: #c152f1;
  /*margin-left: 3px !important;*/

  /*font-size: 12px;*/
  /*color: white;*/
  /*line-height: 2;*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*cursor: pointer;*/
  /*font-family: "Montserrat" !important;*/
  /*animation: flash linear 1s;*/
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.tag-deposit-for-back-to-sales {
  background-color: #4b0082;
  /*border: solid 1.5px yellow;*/
  /*color: white;*/
  /*margin: 2px;*/
  /*line-height: 2;*/
  /*font-weight: 500;*/
  /*padding: 2.5px;*/
  /*cursor: pointer;*/
  /*font-family: "Montserrat" !important;*/
  /*font-size: 11px !important;*/
}

.tag-deposit-today {
  background-color: #c152f1;
  border-radius: 5px;
  padding: 2px;
  /*color: white;*/
  /*padding: 3px;*/
  /*cursor: pointer;*/
  /*line-height: 2;*/
  /*font-family: "Montserrat" !important;*/
  /*font-size: 12px !important;*/
  /*margin: 0;*/
  /*font-weight: 500;*/
}

.tag-deposit-today-cc {
  background-color: black;
  /*color: white;*/
  /*padding: 3px;*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
  /*font-family: "Montserrat" !important;*/
  /*font-size: 12px !important;*/
  /*margin: 0;*/
  /*font-weight: 500;*/
  padding: unset !important;
  margin-left: 0px !important;
}

.tag-deposit-overlay {
  /*background-image: linear-gradient(to right, black, #aa00ff);*/
  background-image: linear-gradient(to right, #aa00ff, black);
  border-radius: 5px;
  padding: 2px;
  /*color: white;*/
  /*padding: 3px;*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
  /*font-family: "Montserrat" !important;*/
  /*font-size: 12px !important;*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
}

.tag-table {
  /*width: 1049px !important;*/
  bottom: 34px !important;
  border: solid 1px #aa00ff;
  border-radius: 5px !important;
  overflow-y: auto;
  max-height: 278px;
  text-align: center;
  /*
  transform: scaleX(-1);
*/
}

.tag-table-small {
  /*  position: absolute;
  top: 24px;
  left: -120px;
  width: max-content;
  z-index: 10001;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: "Montserrat" !important;
  font-size: 12px;*/

  right: 130px !important;
  bottom: 26px !important;
  text-align: center;

  border: solid 1px #000;
  /*
  transform: scaleX(-1);
*/
}

.tag-history-table {
  position: absolute;
  top: 24px;
  right: 500px;
  width: max-content;
  z-index: 10001;
  background-color: #fff;

  border-radius: 5px;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: "Montserrat" !important;
  font-size: 12px;
}

/*.info-icon{
      color: white;
      font-size: 11pt;
      margin-left: 5px;
      margin-right:5px;
      cursor: pointer;
    }*/

.table-responsive {
  border-radius: 5px;
  max-height: 260px;
  overflow: auto;
}

.amount-select {
  width: 80%;
  border-radius: 4px;
  color: black;
  background: #fff;
  max-width: 100%;
  height: 20px;
  font-size: 8pt;
  border-style: solid;
  border-color: #90a4ae;
}

.deposit-select {
  width: 90%;
  border-radius: 4px;
  color: black;
  background: #fff;
  max-width: 100%;
  height: 20px;
  font-size: 8pt;
  border-style: solid;
  border-color: #90a4ae;
}

.tag-time {
  /*font-size: 10px !important;*/
}

.remove-tag-icon {
  /*color: #f44336;*/
  /*cursor: pointer;*/
  color: white;
  cursor: pointer;
  margin-left: 0px;
  position: absolute;
  left: 11px;
  font-size: 17px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 6px !important;
  padding-right: 6px;
  border: 1px solid black;
  border-radius: 5px;
  top: 6px;
  background: black;
}

.remove-tag-icon:hover {
  color: white !important;
  background: black !important;
}

.table-left {
  float: left;
}

.table-right {
  float: right;
}

.table-history {
  height: auto;
  max-height: 250px;
  /*overflow-x: hidden;*/
  margin-top: -9px;
}
.history-btn:focus,
.history-btn:active {
  outline: none !important;
}
.history-btn {
  font-family: Montserrat;
  height: 25px;
  background: #efefef;
  color: black;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 10px;
  margin-bottom: 5px;
  line-height: 12px;
}

.table {
  margin-bottom: 0px;
  /*  transform: scaleX(-1);*/
  direction: ltr;
}

.duplicate-assignment-dropdown-menu {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;
  border-radius: 0;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: "Montserrat" !important;
  font-size: 12px;
}

.date-dropdown-menu {
  position: absolute;
  left: 0px;
  padding: 5px;
  height: 65px;
  width: 50px;
  background: white;
  z-index: 10001;
  border-radius: 0;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.date-dropdown-menu-broker-call {
  position: absolute;
  right: 350px;
  bottom: 3px;
  padding: 5px;
  height: 320px;
  width: fit-content;
  background: white;
  z-index: 10001;
  border-radius: 0;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}
.mx-datepicker-main mx-datepicker-popup {
  z-index: 110 !important;
}
.mx-dt-pic {
  width: 45px !important;
}

.input-date {
  max-width: 100px;
}

.broker-dropdown-menu {
  position: absolute;
  text-align: center;
  left: 200px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;
  border-radius: 0;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.user-dropdown-menu {
  position: absolute;

  left: 110px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;
  text-align: center;
  border-radius: 0;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.second-deposit-dropdown {
  left: unset;
  margin-left: -25px;
}

.currency-dropdown-menu {
  position: absolute;

  left: 350px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;
  text-align: center;
  border-radius: 0;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.status-dropdown-menu {
  position: absolute;
  top: 0;
  //left: 400px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;
  text-align: center;
  border-radius: 0;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.method-dropdown-menu {
  position: absolute;

  left: 350px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;
  text-align: center;
  border-radius: 0;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.add-tag-menu-item-title {
  margin: 5px;
  font-size: 9pt;
  font-weight: bold;
}

.assign-menu-item {
  margin: 5px;
  font-size: 9pt;
  font-family: "Montserrat", Montserrat, serif;
}

.assign-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.fas {
  padding-left: 10px;
}
.fas:hover {
  background: #ffffff;
  cursor: pointer;
}

.cancel-edit-menu-item {
  color: #f44336;
  font-weight: bold;
  cursor: pointer;
}
.apply-edit-menu-item {
  color: green;
  font-weight: bold;
  cursor: pointer;
  margin-right: 20px;
}

.removed-comment-box {
  width: 230px;
  height: 150px;
}
.td-edit {
  cursor: pointer;
  text-align: left;
}

.td-edit:hover {
  background: #fff9c4;
}

.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}
.broker_support_email {
  font-size: 12px;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}

input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
        margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

.date-pic {
  width: 120px;
}

.picker {
  position: absolute;
  max-width: 120px;
}

.spinner-bottom-ms {
  float: right;
  margin-right: 20px;
}

.show-spec-btn {
  cursor: pointer;
}

.show-spec-btn:hover {
  background: #bbdefb;
}

.trans-approved-before {
  color: green;
}

.trans-approved {
  color: green;
  font-weight: bold;
}

.trans-declined {
  color: red;
  font-weight: bold;
}

.nav {
  height: 25px;
}
.nav-tabs {
  display: flex;
  flex-direction: row-reverse;
  /*
  transform: scaleX(-1);
*/
  direction: ltr;
}
.nav-tabs a {
  height: 25px;
  padding: 5px;
}
/*.nav-tabs li{*/
/*  font-size: 12px;*/
/*}*/
.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom: 2px solid;
  border-bottom-color: #1e88e5;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 12px;
  font-weight: bold;
  color: #1e88e5;
}

.bttn {
  width: fit-content;
  margin-top: 0.5rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}
.comment-box-scheduled {
  height: 75px;
}
.text-counter-scheduled {
  float: left;
  font-size: 8pt;
}
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
.tag-table .history-btn {
  float: right;
  padding: 5px;
  bottom: 26px !important;
}
.reason-for-remove {
  position: absolute;
  left: 400px;
  padding: 5px;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background: white;
  list-style: none;
  z-index: 10001;
  text-align: center;
  border-radius: 0;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}
.reason-for-remove p {
  margin: 5px;
  font-size: 9pt;
  font-family: "Montserrat", Montserrat, serif;
}
.pl-1 ml-1,
.ml-1 {
  padding: 4px;
}
.tagNameDesign:hover {
  font-size: 12px !important;
}
.inBetweenSelectedCalDates {
  /*background: lightgrey;*/
  /*border: 1px solid white !important;*/
  color: blue;
}

table {
  border-collapse: separate !important;
}
/*td { border: solid 1px #000 !important; }*/
/*tr td {*/
/*  border-bottom: 1px solid white !important;*/
/*}*/
/*tr td:first-child {*/
/*  border-top-left-radius: 10px !important;*/
/*}*/
/*tr td:last-child {*/
/*  border-top-right-radius: 10px !important;*/
/*}*/
/*tr td:first-child {*/
/*  border-bottom-left-radius: 10px !important;*/
/*}*/
/*tr td:last-child {*/
/*  border-bottom-right-radius: 10px !important;*/
/*}*/
.forNumOutOfName {
  font-weight: 100;
}
.clickable {
  color: lightskyblue;
}
.pop-up-for-tags {
  max-width: fit-content;
  /*<!--right: -37px;-->*/
  font-size: 12px;
  max-width: 1189px;
  right: -204px !important;
  direction: rtl;
}

tbody > tr:nth-of-type(odd) {
  background-color: #7a7a7a0d;
}
.t-header {
  position: sticky;
  top: 0;
  background-color: white !important;
  text-align: revert !important;
}
.pointer {
  cursor: pointer;
  background-color: unset;
}
.for-history-btn {
  padding-bottom: 10px;
  display: flex;
  /*
  transform: scaleX(-1);
*/
  direction: ltr;
}
/* width */
/*::-webkit-scrollbar {
  width: 3px;
}

!* Handle *!
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}*/

.tag-table::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.tag-table::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.tag-table::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
.pointer:hover {
  background-color: unset !important;
}
th.t-header {
  z-index: 2;
}
.question-table {
  bottom: 40px !important;
  /*
  //border: solid 1px #aa00ff;
*/
  border-radius: 5px !important;
  /* overflow-y: auto; */
  max-height: 240px;
  text-align: center;
  left: -757px;
  max-width: 1400px;
}
.clickable:hover {
  background-color: unset !important;
}
.fa-check:hover {
  background-color: unset !important;
}
.for-symbol {
  text-align: center;
}
.for-broker-name {
  text-align: center;
}
td.text-right.for-methods {
  text-align: center;
}
.comment-p:hover .tool-comment {
  visibility: visible;
}

.tool-comment {
  visibility: hidden;
  width: fit-content;
  font-size: 0.7vw;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  /*padding: 5px 0;*/
  position: absolute;
  z-index: 2;
}
.fa-times {
  cursor: pointer;
}
li.for-fa-times {
  padding: 5px;
}
.BlackCc {
  background-color: black;
}

li.for-last-call {
  left: 9px;
  position: absolute;
  top: 5px;
  color: #00a700;
  font-weight: 800;
}
</style>
